<template>
  <div class="svg-button" :class="{active: active}" @click="$emit('action', $event)">
    <slot />
  </div>
</template>

<script>
  export default {
    name: "SvgButton",
    props: {
      active: Boolean,
    }
  }
</script>

<style lang="scss">
@import "@/scss/mixins";

.svg-button {
  position: relative;
  pointer-events: auto;
  overflow: hidden;
  cursor: pointer;
  border: var(--border-mid);
  @include filled-shadow(4);
  border-radius: 12px;
  box-sizing: border-box;

  min-width: 54px;
  min-height: 54px;

  background-color: var(--theme-bg);
  color: var(--theme-fg);

  &.active {
    background-color: var(--theme-bg-light);
  }

  &:active {
    box-shadow: none;
    transform: translate(4px, 4px);
  }

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    height: 1.8em;
  }
}
</style>